import * as React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { Divider } from '@components/Divider';

import { Clear } from '../styled';

import { Container, Wrapper, Title } from './styled';

export interface ISectionContainerProps {
  titleMessage?: MessageDescriptor;
  titleId?: string;
  containerId?: string;
  listLabel?: string;
  withDivider?: boolean;
  children: React.ReactNode;
  titleClassName?: string;
}

export const SectionContainer = React.forwardRef<
  HTMLDivElement,
  ISectionContainerProps
>(
  (
    {
      containerId,
      withDivider,
      titleId,
      titleMessage,
      children,
      titleClassName,
    },
    ref
  ) => {
    return (
      <>
        <Container
          id={containerId}
          key={containerId}
          withDivider={withDivider}
          data-testid="pd-blog-articles-header"
        >
          <Wrapper ref={ref}>
            {withDivider && <Divider shouldShowOnMobile={false} />}

            {Boolean(titleMessage) && (
              <Title
                data-testid={titleId}
                id={titleId}
                className={titleClassName}
              >
                <FormattedMessage {...titleMessage} />
              </Title>
            )}

            {children}
          </Wrapper>
        </Container>

        <Clear />
      </>
    );
  }
);
